import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { clientDisplayLabel } from "./appointmentUtils";

const AppointmentDeleteDialog = ({ open, appointment, onClose, onConfirm, isDeleting }) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>Delete appointment?</DialogTitle>
    <DialogContent>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {appointment?.title || "This appointment"} will be permanently removed.
      </Typography>
      {appointment && (
        <Typography variant="caption" color="text.secondary">
          Client: {clientDisplayLabel(appointment)}
        </Typography>
      )}
    </DialogContent>
    <DialogActions sx={{ flexWrap: "wrap", gap: 1, px: 2, pb: 2 }}>
      <Button onClick={onClose} disabled={isDeleting}>
        Cancel
      </Button>
      <Button
        color="error"
        variant="outlined"
        disabled={isDeleting}
        onClick={() => onConfirm?.({ sendEmail: false })}
      >
        Delete silently
      </Button>
      <Button
        color="error"
        variant="contained"
        disabled={isDeleting}
        onClick={() => onConfirm?.({ sendEmail: true })}
      >
        Delete & notify client
      </Button>
    </DialogActions>
  </Dialog>
);

export default AppointmentDeleteDialog;
